import { isBrowser } from 'app/infrastructure/universal';

/**
 * Resolve client platform and browser info without intepretations
 */
export function clientInfo() {

  if (!isBrowser) {
    return { platform: 'node' };
  }

  try {
  
    const { platform, userAgent, cookieEnabled, onLine, language, languages, userLanguage} = (navigator as any); // eslint:disable-line

    return {
      browser: userAgent,
      cookieEnabled,
      language: { language, languages, userLanguage },
      platform,
      timezone: new Date().getTimezoneOffset(),
      online: onLine,
      url: window.location.href
    };

  } catch (err) {
    console.error('Failed to obtain client info', err.message);
    return {};
  }
}
